module.exports = __webpack_public_path__ + "img/hr-giving-back.473f353c.png";